<template>
  <!-- BEGIN pos-counter -->
  <div class="pos pos-counter ts-overflow-hidden" v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
    id="pos-counter">
    <!-- Hidden NFC Scanner Component -->
    <!-- @nfc-scanned="handleNFCScan" -->
    <NFCScanner ref="nfcScanner" @scan-started="handleScanStarted" @scan-ended="handleScanEnded"
      @scan-success="handleScanSuccess" @scan-error="handleScanError" @scanner-ready="handleScannerReady" />

    <!-- Header Component -->
    <PosCounterHeader :time="time" :tableBusy="tableBusy" :totalTable="totalTable" :flag="flag" :languages="languages"
      :fullscreen="fullscreen" @openFullscreen="openFullscreen" @closeFullscreen="closeFullscreen"
      @changeLanguage="changeLanguage" />

    <!-- Body Component -->
    <PosCounterBody :tableLists="tableLists" :tableFetching="tableFetching" :selected_table="selected_table"
      :tableSelected="tableSelected" :posMobileSidebar="posMobileSidebar" :defaultCrrency="defaultCrrency"
      :vatRate="vatRate" :printing="printing" @onTableSelected="onTableSelected"
      @posMobileSidebarToggled="posMobileSidebarToggled" @removeItem="removeItem"
      @showCombineTableForm="showCombineTableForm" @moveTable="moveTable" @cleanTable="cleanTable"
      @cancelOrder="cancelOrder" @addMoreOrder="addMoreOrder" @printBill="printBill" @showBillForm="showBillForm"
      @showShiftCloseForm="showShiftCloseForm" @showLinkedKeysForm="onShowLinkedKeys"
      @onMemberCheckout="onMemberCheckout" @fetchTableByInterval="fetchTableByInterval"
      @showQueueListForm="showQueueListForm" @showMemberCardForm="showMemberCardForm" />

    <!-- Modals -->
    <a-modal v-if="showForm" v-model="showForm" :title="$t('restaurantSale.shiftClose')" centered @cancel="closeForm"
      :zIndex="1020" :footer="null" width="500px" :maskClosable="false">
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>

    <!-- <a-modal v-if="showLinkedKeysForm" v-model="showLinkedKeysForm" :title="$t('restaurantSale.linkedKey')" centered
      @cancel="closeLinkedKeysForm" :zIndex="1020" :footer="null" width="80%">
      <linked-keys :tableSelected="tableSelected" @cancel="closeLinkedKeysForm" />
    </a-modal> -->

    <modal name="modalLinkedKeys" height="auto" width="80%" :scrollable="true" draggable=".form-header"
      :clickToClose="false">
      <linked-keys :tableSelected="tableSelected" @cancel="closeLinkedKeysForm"
        @fetchTableByInterval="fetchTableByInterval" ref="linkedKeys" />
    </modal>

    <modal name="modalMemberCard" height="auto" width="80%" :scrollable="true" draggable=".form-header"
      :clickToClose="false">
      <MemberCard :tableSelected="tableSelected" :ref_customer_member_card_id="ref_customer_member_card_id"
        @onTableSelected="onTableSelected" @cancel="closeMemberCard" />
    </modal>

    <modal name="modalMemberCheckOut" height="auto" width="80%" :scrollable="true" draggable=".form-header"
      :clickToClose="false">
      <MemberCheckOut :tableSelected="tableSelected" @onTableSelected="onTableSelected" @cancel="closeMemberCheckOut" />
    </modal>

    <modal name="modalQueueList" height="auto" width="80%" :scrollable="true" draggable=".form-header"
      :clickToClose="false">
      <QueueList :tableSelected="tableSelected" :ref_customer_member_card_id="ref_customer_member_card_id"
        @onTableSelected="onTableSelected" @cancel="closeQueueListForm" @fetchTableByInterval="fetchTableByInterval" />
    </modal>

    <a-modal v-if="showMember" v-model="showMember" centered @cancel="closeMemberCardForm" :zIndex="1020" :footer="null"
      width="100%" wrapClassName="full-modal">
      <MemberContent />
    </a-modal>

    <a-modal v-if="showPreviewReciept" v-model="showPreviewReciept" :title="$t('restaurantSale.previewReciept')"
      centered @cancel="closeForm" :zIndex="1020" :footer="null" width="400px">
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>
  </div>
  <!-- END pos-counter -->
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
// import NumberCustomer from './counter-checkout-components/number-of-customer'
import CombineTable from './counter-checkout-components/combine-table'
import MoveTable from './counter-checkout-components/move-table'
import CheckBill from './counter-checkout-components/check-bill'
import ShiftClose from './counter-checkout-components/shift-close'
import LinkedKeys from './counter-checkout-components/linked-keys.vue'
import MemberCard from './counter-checkout-components/member-card.vue'
import MemberCheckOut from './counter-checkout-components/member-check-out.vue'
import QueueList from './counter-checkout-components/queue-list.vue'
import MemberContent from './counter-checkout-components/member-content.vue'
import PosCounterHeader from './counter-checkout-components/PosCounterHeader.vue'
import PosCounterBody from './counter-checkout-components/PosCounterBody.vue'
import NFCScanner from './counter-checkout-components/NFCBackgroundListener.vue'
import { mapActions } from 'vuex'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
import Reason from './components/reason-delete'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    ShiftClose,
    LinkedKeys,
    MemberCard,
    MemberCheckOut,
    QueueList,
    MemberContent,
    PosCounterHeader,
    PosCounterBody,
    NFCScanner
  },
  created() {
    PageOptions.pageEmpty = true
    PageOptions.pageFullHeight = true
    this.handleStartTime()
    this.fetchTables()
    this.fetchCustomerMemberCard()
    this.fetchProducts()
    this.fetchBefore().finally(() => {
      this.defaultCheckTable(this.table_id)
    })
  },
  mounted() {
    if ('NDEFReader' in window) {
      this.startScan()
    }
    this.interval = setInterval(() => {
      this.fetchTableByInterval()
    }, 30000)
    // Configure scanner if needed
    this.$nextTick(() => {
      if (this.$refs.nfcScanner) {
        // Set custom validation parameters
        this.$refs.nfcScanner.setMinLength(6) // Minimum 6 characters
        this.$refs.nfcScanner.setMaxLength(30) // Maximum 30 characters
        this.$refs.nfcScanner.setScanDelay(150) // Wait 150ms after last key
      }
    })
  },
  beforeDestroy() {
    // Clean up resources
    this.stopScan()
    this.clearProcessingState()

    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    PageOptions.pageFullHeight = false
    next()
  },
  data: function () {
    return {
      model: {
        deleted_reason: null
      },
      counter: {
        counter_id: undefined
      },
      time: '00:00',
      tableFetching: false,
      loading: false,
      printing: false,
      cleaning: false,
      posMobileSidebar: false,
      showForm: false,
      showLinkedKeysForm: false,
      // showMemberCardForm: false,
      showMemberCardCheckIn: false,
      showMember: false,
      showPreviewReciept: false,
      selected_table: 0,
      tableSelected: {},
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      interval: null,
      fullscreen: false,
      errors: new Errors(),
      message: 'Ready to scan NFC tags...',
      ndef: null,
      interval: null,
      isScanning: false,
      isProcessingFee: false,
      processingSerialNumbers: new Set(), // Track currently processing serial numbers
      lastProcessedSerial: null,
      lastProcessedTime: 0,
      audioContext: 'scan',
      scannerActive: false,
      ref_customer_member_card_id: null
    }
  },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
    },
    table_id() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
        .table_id
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .to_currency
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    },
    tableBusy() {
      return this.tableLists.filter(t => t.status_id != 1).length
    },
    totalTable() {
      return this.tableLists.length
    }
  },
  methods: {
    ...mapActions('restaurantSale/customerOrder', ['fetchBefore']),
    fetchProducts(attributes) {
      this.$store.dispatch(
        'restaurantSale/customerOrder/fetchProducts',
        attributes
      )
    },
    fetchTableByInterval(attributes) {
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
    },
    fetchTables(attributes) {
      this.tableFetching = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.tableFetching = false))
    },
    fetchCustomerMemberCard(attributes) {
      this.tableFetching = true
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/fetchCustomerMemberCard',
          attributes
        )
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH MEMBER CARD',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.tableFetching = false))
    },
    onShowLinkedKeys(table) {
      this.$modal.show('modalLinkedKeys')
      this.showLinkedKeysForm = true
      this.posMobileSidebar = false
    },
    onMemberCheckout(table) {
      this.tableSelected = table
      this.showMemberCardCheckIn = true
      this.$modal.show('modalMemberCheckOut')
    },
    cleanTable() {
      this.posMobileSidebar = !this.posMobileSidebar
      this.cleaning = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/cleanTable', this.table_id)
        .then(response => {
          this.laodAndClearTable()
          if (response.message_id == 0) {
            this.$notification['success']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          } else {
            this.$notification['warning']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.cleaning = false))
    },
    moveTable() {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show(
        MoveTable,
        {
          data: {}
        },
        {
          height: 'auto',
          width: '350px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    },
    onTableSelected(table) {
      this.openFullscreen()
      setTimeout(() => {
        if (table.status_id == 1) {
          this.selected_table = 0
          this.tableSelected = {}
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            {}
          )
          this.addOrder(table)
        }
        if (table.status_id == 2) {
          this.selected_table = 0
          this.tableSelected = {}
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            {}
          )
          this.showConfirm(table)
        }
        if (table.status_id == 3) {
          if (table.table_id == this.table_id) {
            this.selected_table = 0
            this.tableSelected = {}
            this.$store.commit(
              'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
              {}
            )
          } else {
            this.posMobileSidebar = !this.posMobileSidebar
            this.$store.commit(
              'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
              table
            )
            this.tableSelected = table
            this.selected_table = table.table_id
          }
        }
      }, 500)
    },
    addOrder(table) {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        table
      )
      this.$router.push({ name: 'customer-order' })
    },
    async removeItem(item) {
      await this.$store
        .dispatch('restaurantSale/customerOrder/deleteItemOrdered', item)
        .then(() => {
          this.tableSelected.invoice_detail.splice(
            this.tableSelected.invoice_detail.indexOf(item),
            1
          )
        })
        .catch(error => {
          this.$toasted.error(error.messages)
        })
        .finally(() => {
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
        })
    },
    posMobileSidebarToggled: function () {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    defaultCheckTable(table_id) {
      if (table_id) {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.table_id == table_id)
            .reduce((init, value) => (init = value), {})
        )
      }
      // else {
      //   this.autoSelectedTable(
      //     this.$store.state.restaurantSale.counterCheckout.tables
      //       .filter(t => t.status_id == 3)
      //       .reduce((init, value) => (init = value), {})
      //   )
      // }
    },
    autoSelectedTable(table) {
      if (table.status_id == 3) {
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          table
        )
        this.tableSelected = table
        this.selected_table = table.table_id
      }
    },
    addMoreOrder() {
      this.$router.push({ name: 'customer-order' })
    },
    showCombineTableForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar

      // Disable NFC scanner
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }

      this.$modal.show(
        CombineTable,
        {
          data: table
        },
        {
          height: 'auto',
          width: '100%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        },
        {
          'before-close': () => {
            // Re-enable scanner when closing
            if (this.$refs.nfcScanner) {
              this.$refs.nfcScanner.enableScanner()
            }
          }
        }
      )
    },
    showQueueListForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show('modalQueueList')
    },
    closeQueueListForm(table) {
      this.$modal.hide('modalQueueList')
    },
    showMemberCardForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar
      this.showMember = true
    },
    closeMemberCardForm(table) {
      console.log('sad');
      this.fetchCustomerMemberCard()
      this.showMember = false
    },
    showBillForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar

      // Disable NFC scanner when bill modal opens
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }

      this.$modal.show(
        CheckBill,
        {
          data: table
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.laodAndClearTable
        }
      )
    },
    laodAndClearTable() {
      // Re-enable NFC scanner when bill modal closes
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.enableScanner()
      }

      this.tableSelected = {}
      this.selected_table = 0
      this.fetchTables()
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    showConfirm(table) {
      const self = this
      setTimeout(() => {
        this.$confirm({
          title: table.num_pax_order_book_status,
          content: this.$t('restaurantSale.doYouWantToCleanTableAndMakeOrder'),
          onOk() {
            self.isCustomerCome(table)
          },
          okText: 'Yes',
          cancelText: 'No',
          centered: true,
          onCancel() {
            self.$destroyAll()
          }
        })
      }, 500)
    },
    isCustomerCome(table) {
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/isCustomerCome',
          table.booking_id
        )
        .then(() => {
          this.laodAndClearTable()
          this.addOrder(table)
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
    },
    closeForm() {
      this.showForm = false
      // Re-enable NFC scanner when form closes
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.enableScanner()
      }
    },
    closeLinkedKeysForm() {
      this.$modal.hide('modalLinkedKeys')
      this.showLinkedKeysForm = false
      this.fetchTables()
    },
    closeMemberCard() {
      this.ref_customer_member_card_id = null
      this.$modal.hide('modalMemberCard')
    },
    closeMemberCheckOut() {
      this.showMemberCardCheckIn = false
      this.$modal.hide('modalMemberCheckOut')
    },
    receiptPreview() {
      this.showPreviewReciept = true
    },
    printBill() {
      this.printing = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/printBill', {
          stock_out_id: this.tableSelected.stock_out_id,
          counter_id: localStorage.getItem('counterId'),
          action_type: 'print-bill'
        })
        .then(() => { })
        .catch(error => {
          this.$notification['error']({
            message: 'Print Bill',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.printing = false
        })
    },
    showShiftCloseForm() {
      this.posMobileSidebar = !this.posMobileSidebar
      this.showForm = true
      // Disable NFC scanner when shift close modal opens
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    openFullscreen() {
      if (!this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    closeFullscreen() {
      if (this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    cancelOrder() {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('Are you sure to cancel order?'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('restaurantSale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('restaurantSale/counterCheckout/cancelOrder', {
              stock_out_id: this.tableSelected.stock_out_id,
              data: this.model
            })
            .then(response => {
              this.tableFetching = true
              this.$toasted.success(response.messages)
              this.$store
                .dispatch('restaurantSale/counterCheckout/fetchTables')
                .then(() => {
                  this.selected_table = 0
                  this.tableSelected = {}
                  this.$store.commit(
                    'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
                    {}
                  )
                  this.tableFetching = false
                })
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        }
      })
    },
    async startScan() {
      // Prevent multiple scans
      if (this.isScanning) {
        // console.log('NFC scanning already active, skipping...')
        return
      }

      if ('NDEFReader' in window) {
        try {
          // Clean up any existing reader first
          this.stopScan()

          // Create NDEFReader instance
          this.ndef = new window.NDEFReader()

          if (!this.ndef) {
            throw new Error(
              'Failed to create NDEFReader - constructor returned null'
            )
          }

          // console.log('NDEFReader created successfully:', this.ndef)

          // Add event listeners FIRST, before calling scan()
          this.ndef.addEventListener('reading', this.handleNFCReading)
          this.ndef.addEventListener('readingerror', this.handleNFCError)

          // console.log('Event listeners added successfully')

          // THEN call scan()
          await this.ndef.scan()
          this.isScanning = true

          // console.log('NFC scanning started successfully')

          // No notification - silent startup
        } catch (err) {
          console.error('StartScan error details:', err)
          this.isScanning = false
          this.ndef = null

          // Only show error notifications
          // this.$notification['error']({
          //   message: 'NFC Initialization Error',
          //   description: err.message || '⚠️ Failed to initialize NFC scanning.',
          //   placement: 'bottomRight'
          // })
        }
      } else {
        this.$notification['error']({
          message: 'Unsupported',
          description:
            'Web NFC is not supported in this browser. Please use Chrome on Android.',
          placement: 'bottomRight'
        })
      }
    },

    stopScan() {
      // console.log('Stopping NFC scan...')

      if (this.ndef) {
        try {
          this.ndef.removeEventListener('reading', this.handleNFCReading)
          this.ndef.removeEventListener('readingerror', this.handleNFCError)
          // console.log('Event listeners removed')
        } catch (error) {
          console.error('Error removing event listeners:', error)
        }
        this.ndef = null
      }

      this.isScanning = false
      // console.log('NFC scanning stopped')
    },

    handleNFCReading(event) {
      const { serialNumber, message } = event

      // console.log('NFC Reading event:', event)
      // console.log('Serial Number:', serialNumber)

      // Global processing check
      if (this.isProcessingFee) {
        // console.log('Already processing a fee, ignoring scan')
        return
      }

      // Validate serial number exists
      if (!serialNumber || serialNumber.trim() === '') {
        this.$notification['warning']({
          message: 'Invalid Scan',
          description: 'No valid serial number detected from NFC tag.',
          placement: 'bottomRight'
        })
        return
      }

      let text = ''
      if (message && message.records) {
        for (const record of message.records) {
          if (record.recordType === 'text') {
            const decoder = new TextDecoder(record.encoding)
            text = decoder.decode(record.data)
          }
        }
      }

      // Set global processing flag
      this.isProcessingFee = true

      // Show immediate scan feedback
      // this.$notification['info']({
      //   message: 'Tag Detected',
      //   description: `Processing NFC tag: ${serialNumber.substring(0, 8)}...`,
      //   placement: 'bottomRight',
      //   duration: 1.5
      // })

      // Process the entrance fee
      // Normalize the serial number to match store format
      const normalizedSerial = this.hexSerialToDecimal(serialNumber.trim())
      this.handleAutoAddPreChargeProducts(normalizedSerial)

      // Reset global flag after processing
      setTimeout(() => {
        this.isProcessingFee = false
      }, 2000)
    },

    handleNFCError(event) {
      // console.log('NFC Error event:', event)
      this.$notification['error']({
        message: 'NFC Error',
        description: '⚠️ Cannot read NFC tag.',
        placement: 'bottomRight'
      })
    },

    // Normalize serial number format
    normalizeSerialNumber(serialNumber) {
      if (!serialNumber) return ''
      // Remove colons and convert to lowercase
      return serialNumber.replace(/:/g, '').toLowerCase()
    },

    // Convert hex serial number to decimal with byte reversal
    hexSerialToDecimal(serialNumber) {
      if (!serialNumber) return 0

      // Normalize the serial number (remove colons, lowercase)
      const normalized = this.normalizeSerialNumber(serialNumber)

      // Reverse byte order: split into pairs, reverse array, join back
      // "53f38476" -> ["53", "f3", "84", "76"] -> ["76", "84", "f3", "53"] -> "7684f353"
      const reversed = normalized
        .match(/.{2}/g)
        .reverse()
        .join('')

      // Convert reversed hex to decimal
      return parseInt(reversed, 16)
    },

    handleAutoAddPreChargeProducts(normalizedSerial) {
      // Prevent rapid duplicate calls for the same serial number
      const now = Date.now()
      const cooldownPeriod = 3000 // 3 seconds cooldown

      if (
        this.lastProcessedSerial === normalizedSerial &&
        now - this.lastProcessedTime < cooldownPeriod
      ) {
        // console.log('Duplicate scan detected, ignoring:', normalizedSerial)
        this.$notification['warning']({
          message: 'Duplicate Scan',
          description: 'Please wait before scanning the same card again.',
          placement: 'bottomRight',
          duration: 1.5
        })
        return
      }

      // Prevent processing the same serial number simultaneously
      if (this.processingSerialNumbers.has(normalizedSerial)) {
        // console.log('Already processing this serial number:', normalizedSerial)
        // this.$notification['warning']({
        //   message: 'Processing',
        //   description: 'This card is already being processed.',
        //   placement: 'bottomRight',
        //   duration: 1.5
        // })
        return
      }

      // Add to processing set
      this.processingSerialNumbers.add(normalizedSerial)

      try {
        const customer_member_cards = this.$store.state.restaurantSale.counterCheckout.customer_member_cards.find(
          t =>
            String(t.serial_card).padStart(10, '0') === normalizedSerial ||
            String(t.serial_card) === normalizedSerial ||
            parseInt(t.serial_card) === parseInt(normalizedSerial)
        )

        if (customer_member_cards) {
          if (this.$store.state.restaurantSale.counterCheckout.tables.find(el => el.ref_customer_member_card_id == customer_member_cards.customer_member_card_id)) {
            this.$notification['warning']({
              message: 'Check-in',
              description: 'Member Card is already actived!',
              placement: 'bottomRight'
            })
            return
          }
          this.ref_customer_member_card_id =
            customer_member_cards.customer_member_card_id
          this.$modal.show('modalMemberCard')
          if (this.tableSelected) {
            if (!this.tableSelected.stock_out_id) {
              this.tableSelected.ref_customer_member_card_id =
                customer_member_cards.customer_member_card_id
              this.tableSelected.customer_id = customer_member_cards.customer_id
              this.onTableSelected(this.tableSelected)
            }
          }
          return
        }

        let table = null

        if (this.ref_customer_member_card_id) {
          // Use normalized serial to find table
          table = this.$store.state.restaurantSale.counterCheckout.tables.find(
            t =>
              String(t.serial_card).padStart(10, '0') === normalizedSerial ||
              String(t.serial_card) === normalizedSerial ||
              parseInt(t.serial_card) === parseInt(normalizedSerial) &&
              t.guest_level_id == 1
          )

          if (!table) {
            this.$notification['warning']({
              message: 'Processing Error',
              description: `Memeber card only for normal lockers. Please try another table.`,
              placement: 'bottomRight'
            })
            return
          }
        } else {
          // Use normalized serial to find table
          table = this.$store.state.restaurantSale.counterCheckout.tables.find(
            t =>
              String(t.serial_card).padStart(10, '0') === normalizedSerial ||
              String(t.serial_card) === normalizedSerial ||
              parseInt(t.serial_card) === parseInt(normalizedSerial)
          )
        }

        // console.log(
        //   'Available tables:',
        //   this.$store.state.restaurantSale.counterCheckout.tables.map(
        //     t => t.serial_card
        //   )
        // )
        // console.log('Looking for table with serial:', normalizedSerial)
        // console.log('Found table:', table)

        // Case 1: Serial number not found
        if (!table) {
          this.$notification['warning']({
            message: 'Invalid Serial Number',
            description: `The serial number: ${normalizedSerial} you entered was not found.`,
            placement: 'bottomRight'
          })
          return
        }

        // Case 2: Table status is not 1
        if (table.status_id !== 1) {
          // Update last processed info
          this.lastProcessedSerial = normalizedSerial
          this.lastProcessedTime = now
          this.onTableSelected(table)

          // this.$notification['warning']({
          //   message: 'Table Not Available',
          //   description:
          //     'The table you selected is not available. Please select another table.',
          //   placement: 'bottomRight'
          // })
          return
        }

        // Update last processed info
        this.lastProcessedSerial = normalizedSerial
        this.lastProcessedTime = now

        // Show success feedback
        // this.$notification['success']({
        //   message: 'Table Selected',
        //   description: `Table ${table.table_number ||
        //     table.name} selected successfully.`,
        //   placement: 'bottomRight',
        //   duration: 2
        // })

        table.ref_customer_member_card_id = this.ref_customer_member_card_id

        // If passes both validations, continue
        this.onTableSelected(table)

        this.ref_customer_member_card_id = null
      } catch (error) {
        console.error('Error in handleAutoAddPreChargeProducts:', error)
        this.$notification['error']({
          message: 'Processing Error',
          description:
            'An error occurred while processing the table selection.',
          placement: 'bottomRight'
        })
      } finally {
        // Remove from processing set after a short delay
        setTimeout(() => {
          this.processingSerialNumbers.delete(normalizedSerial)
        }, 1000)
      }
    },
    handleAutoLinkedKeys(normalizedSerial) {
      // Prevent rapid duplicate calls for the same serial number
      const now = Date.now()
      const cooldownPeriod = 3000 // 3 seconds cooldown

      if (
        this.lastProcessedSerial === normalizedSerial &&
        now - this.lastProcessedTime < cooldownPeriod
      ) {
        // console.log('Duplicate scan detected, ignoring:', normalizedSerial)
        this.$notification['warning']({
          message: 'Duplicate Scan',
          description: 'Please wait before scanning the same card again.',
          placement: 'bottomRight',
          duration: 1.5
        })
        return
      }

      // Prevent processing the same serial number simultaneously
      if (this.processingSerialNumbers.has(normalizedSerial)) {
        // console.log('Already processing this serial number:', normalizedSerial)
        // this.$notification['warning']({
        //   message: 'Processing',
        //   description: 'This card is already being processed.',
        //   placement: 'bottomRight',
        //   duration: 1.5
        // })
        return
      }

      // Add to processing set
      this.processingSerialNumbers.add(normalizedSerial)

      try {
        // Use normalized serial to find table
        const table = this.$store.state.restaurantSale.counterCheckout.tables.find(
          t =>
            String(t.serial_card).padStart(10, '0') === normalizedSerial ||
            String(t.serial_card) === normalizedSerial ||
            parseInt(t.serial_card) === parseInt(normalizedSerial)
        )

        // Case 1: Serial number not found
        if (!table) {
          this.$notification['warning']({
            message: 'Invalid Serial Number',
            description: `The serial number: ${normalizedSerial} you entered was not found.`,
            placement: 'bottomRight'
          })
          return
        }

        // Case 2: Table status is not 1
        if (table.status_id !== 1) {
          // Update last processed info

          this.$notification['warning']({
            message: 'Locker Not Available',
            description:
              'The locker you selected is not available. Please select another locker.',
            placement: 'bottomRight'
          })
          return
        }

        if (table.guest_level_id == 1) {
          this.$notification['warning']({
            message: 'LINKED KEY',
            description: `The serial number: ${normalizedSerial} you entered is not vip locker!`,
            placement: 'bottomRight'
          })
          return
        }
        this.lastProcessedSerial = normalizedSerial
        this.lastProcessedTime = now

        this.$refs.linkedKeys.onTableSelected(table)
        return
      } catch (error) {
        console.error('Error in handleAutoAddPreChargeProducts:', error)
        this.$notification['error']({
          message: 'Processing Error',
          description:
            'An error occurred while processing the table selection.',
          placement: 'bottomRight'
        })
      } finally {
        // Remove from processing set after a short delay
        setTimeout(() => {
          this.processingSerialNumbers.delete(normalizedSerial)
        }, 1000)
      }
    },
    handleMemberCardCheckIn(normalizedSerial) {
      // Prevent rapid duplicate calls for the same serial number
      const now = Date.now()
      const cooldownPeriod = 3000 // 3 seconds cooldown

      if (
        this.lastProcessedSerial === normalizedSerial &&
        now - this.lastProcessedTime < cooldownPeriod
      ) {
        // console.log('Duplicate scan detected, ignoring:', normalizedSerial)
        this.$notification['warning']({
          message: 'Duplicate Scan',
          description: 'Please wait before scanning the same card again.',
          placement: 'bottomRight',
          duration: 1.5
        })
        return
      }

      // Prevent processing the same serial number simultaneously
      if (this.processingSerialNumbers.has(normalizedSerial)) {
        // console.log('Already processing this serial number:', normalizedSerial)
        // this.$notification['warning']({
        //   message: 'Processing',
        //   description: 'This card is already being processed.',
        //   placement: 'bottomRight',
        //   duration: 1.5
        // })
        return
      }

      // Add to processing set
      this.processingSerialNumbers.add(normalizedSerial)

      try {
        const customer_member_cards = this.$store.state.restaurantSale.counterCheckout.customer_member_cards.find(
          t =>
            String(t.serial_card).padStart(10, '0') === normalizedSerial ||
            String(t.serial_card) === normalizedSerial ||
            parseInt(t.serial_card) === parseInt(normalizedSerial)
        )

        if (customer_member_cards) {
          this.ref_customer_member_card_id =
            customer_member_cards.customer_member_card_id
          if (this.tableSelected) {
            if (!this.tableSelected.stock_out_id) {
              this.tableSelected.ref_customer_member_card_id =
                customer_member_cards.customer_member_card_id
              this.tableSelected.customer_id = customer_member_cards.customer_id
              this.onTableSelected(this.tableSelected)
            }
          }
          return
        } else {
          // Case 1: Serial number not found
          this.$notification['warning']({
            message: 'Invalid Serial Number',
            description: `The serial number: ${normalizedSerial} you entered was not found in member cards!`,
            placement: 'bottomRight'
          })

          // Update last processed info
          this.lastProcessedSerial = normalizedSerial
          this.lastProcessedTime = now
          return
        }
      } catch (error) {
        console.error('Error in handleAutoAddPreChargeProducts:', error)
        this.$notification['error']({
          message: 'Processing Error',
          description:
            'An error occurred while processing the table selection.',
          placement: 'bottomRight'
        })
      } finally {
        // Remove from processing set after a short delay
        setTimeout(() => {
          this.processingSerialNumbers.delete(normalizedSerial)
        }, 1000)
      }
    },
    // Method to manually clear processing state if needed
    clearProcessingState() {
      this.processingSerialNumbers.clear()
      this.isProcessingFee = false
      this.lastProcessedSerial = null
      this.lastProcessedTime = 0
    },

    // Method to restart scanning if needed
    async restartScan() {
      this.stopScan()
      this.clearProcessingState()
      await this.$nextTick()
      this.startScan()
    },

    // handleNFCScan(scanData) {
    //   // Process the scanned value (your business logic here)
    // },

    handleScanStarted() {
      this.isScanning = true
    },

    handleScanEnded() {
      this.isScanning = false
    },

    handleScanSuccess(value) {
      if (this.showLinkedKeysForm) {
        this.handleAutoLinkedKeys(value)
      }
      else if (this.showMemberCardCheckIn) {
        this.handleMemberCardCheckIn(value)
      }
      else {
        this.handleAutoAddPreChargeProducts(value)
      }
    },

    handleScanError(errorData) {
      console.log('Scan error:', errorData)
    },

    handleScannerReady() {
      this.scannerActive = true
    },

    // Method to manually clear scanner buffer if needed
    clearScannerBuffer() {
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.clearBuffer()
      }
    }
  },
  watch: {
    table_id: function (val) {
      if (val) {
        this.defaultCheckTable(val)
      }
    }
  }
}
</script>

<style scoped>
.pos-counter {
  height: 100vh;
}

@media (max-width: 991.98px) {
  .pos-counter {
    height: 111vh;
  }
}
</style>
<style>
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }

  .ant-modal-body {
    flex: 1;
  }
}
</style>